const SDK_VERSION = '8.16.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
